export default __webpack_public_path__ + "static/media/sms-campaign-1.48aff3fd.png";